import { Col, Row } from "react-bootstrap";

export default function LogoMascot() {
  return (
    <div
      style={{
        lineHeight: "2",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {/* Tournament Logo Section */}
      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", marginBottom: "15px" }}>
          आधिकारिक लोगो — "सेपक टाकरा वर्ल्ड कप 2025"
        </h2>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          सेपक टाकरा वर्ल्ड कप 2025 का आधिकारिक लोगो इस भव्य आयोजन की आत्मा और
          उद्देश्य को दर्शाता है। यह लोगो भारत की ऐतिहासिक विरासत, आधुनिक खेल
          संस्कृति और वैश्विक एकता का सुंदर मिश्रण है।
        </p>
        <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>
          लोगो की विशेषताएं:
        </h5>

        <Row style={{ marginBottom: "0px" }}>
          <Col md={8}>
            <ul style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                मंदिर की आकृति: लोगो में भारत की धार्मिक और सांस्कृतिक धरोहर को
                सम्मान देने के लिए मंदिर के आकार का प्रतीक शामिल है। यह बिहार की
                ऐतिहासिक पहचान की याद दिलाता है।
              </li>
              <li style={{ listStyle: "auto" }}>
                सेपक टाकरा की गेंद: लोगो के मध्य में बनी गेंद इस खेल की तेजी,
                कौशल और टीमवर्क को प्रस्तुत करती है। यह दर्शाता है कि कैसे
                खिलाड़ी संतुलन, फुर्ती और रणनीति के साथ खेलते हैं।
              </li>
              <li style={{ listStyle: "auto" }}>
                गहरे और जीवंत रंग:
                <ul>
                  <li style={{ listStyleType: "disc" }}>
                    बैंगनी (शक्ति और साहस){" "}
                  </li>
                  <li style={{ listStyleType: "disc" }}>
                    नारंगी (उत्साह और ऊर्जा){" "}
                  </li>
                  <li style={{ listStyleType: "disc" }}>
                    हरा (समृद्धि और विकास){" "}
                  </li>
                  <li style={{ listStyleType: "disc" }}>पीला (आशा और खुशी) </li>
                </ul>
              </li>
              <li style={{ listStyle: "auto" }}>
                ये रंग भारत की विविधता और जीवन के रंगों का प्रतिनिधित्व करते
                हैं, जो पूरे आयोजन की आत्मा है।
              </li>
              <li style={{ listStyle: "auto" }}>
                वैश्विक प्रतियोगिता का प्रतीक: लोगो की पूरी डिजाइन यह संदेश देती
                है कि सेपक टाकरा वर्ल्ड कप 2025 सिर्फ एक खेल प्रतियोगिता नहीं,
                बल्कि संस्कृति, खेल और अंतरराष्ट्रीय मित्रता का संगम है।
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <img
              src="./img/Logo-Sepak-Takraw.png"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
        <p style={{ textAlign: "justify" }}>
          यह लोगो न केवल खेल प्रेमियों के लिए गर्व का विषय है, बल्कि यह भारत की
          मेहमाननवाज़ी और खेल संस्कृति को भी विश्व मंच पर स्थापित करता है।
        </p>
      </div>

      {/* Mascot Section */}
      <div style={{ lineHeight: "2", marginTop: "50px" }}>
        <h2 style={{ fontSize: "22px", marginBottom: "15px" }}>शुभंकर भीम</h2>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          भीम सेपक टाकरा विश्व कप बिहार 2025 का आधिकारिक शुभंकर भीम बिहार के
          राजकीय पशु बाइसन ( गौड़) से प्रेरित है। भीम केवल ताकत और लचीलेपन का
          प्रतीक नहीं है,बल्कि यह मैत्रीपूर्ण व्यवहार और खेल भावना का भी
          प्रतिनिधित्व करता है। भीम सेपक टाकरा वर्ल्ड कप 2025 का आधिकारिक शुभंकर
          (Mascot) है, जो शक्ति, धैर्य, साहस और भारतीय संस्कृति का अद्भुत प्रतीक
          है।
        </p>
        <Row>
          <Col md={8}>
            {/* key symbolism */}
            <h5 style={{ textAlign: "justify" }}>
              भीम: सेपक टाकरा विश्व कप 2025 का प्रतीक
            </h5>
            <br />
            <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
              <li style={{ listStyleType: "disc" }}>
                ताकत का खिलाड़ी: बाइसन की जबरदस्त ताकत सेपक टाकरा में जोरदार
                किक्स की प्रेरणा देती है।
              </li>
              <li style={{ listStyleType: "disc" }}>
                टीम का सितारा: झुंड में रहने वाला बाइसन टीम वर्क का प्रतीक है,
                जैसे खेल में तालमेल जरूरी है।
              </li>
              <li style={{ listStyleType: "disc" }}>
                चपलता और संतुलन: भारी शरीर के बावजूद तेज और संतुलित—सेपक टाकरा
                के खिलाड़ियों की तरह।
              </li>
              <li style={{ listStyleType: "disc" }}>
                धैर्य का धुरंधर: शांत और सहनशील बाइसन सिखाता है कि मुश्किल शॉट्स
                में धैर्य ही जीत दिलाता है।
              </li>
              <li style={{ listStyleType: "disc" }}>
                साहस का प्रतीक: बड़े सींगों वाला बाइसन चुनौतियों से नहीं डरता,
                ठीक वैसे ही जैसे खिलाड़ी ऊँची किक्स लगाते हैं।
              </li>
              <li style={{ listStyleType: "disc" }}>
                खेल भावना का चैंपियन: शाकाहारी और मैत्रीपूर्ण बाइसन खेल की सच्ची
                भावना दर्शाता है।
              </li>
              <li style={{ listStyleType: "disc" }}>
                मैदान का बादशाह: जंगल में प्रभावशाली, तो सेपक टाकरा 2025 में भीम
                जोश भरने को तैयार!
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <img
              src="./img/sepak-takraw-bheem.png"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
